import { Badge } from "@mantine/core";
import { useSystemUsers } from "../../../hooks/useSystemUsers";
import type { Todo } from "../../../utils/backend-types";
import { TodoStatus } from "../../../utils/backend-types";
import { useTodos } from "../../Todos/hooks/useTodos";
import { Mode } from "../../Todos/Todos.types";

interface OnboardingCounterProps {
  variantId: number;
}

function OnboardingCounter({ variantId }: OnboardingCounterProps) {
  const {
    todos,
    isLoading: isTodosLoading,
    error: todosError
  } = useTodos({
    mode: Mode.Onboarding,
    variantId: variantId
  });

  const {
    isLoading: isUsersLoading,
    error: usersError,
    data: users
  } = useSystemUsers();

  if (isTodosLoading || todosError || isUsersLoading || usersError) {
    return null;
  }

  const onboardingTeamUser = users?.find(
    (user) => user.name === "Onboarding Team"
  );

  function filterRelevantTodos(todo: Todo) {
    if (onboardingTeamUser) {
      return (
        todo.status === TodoStatus.Open &&
        todo.responsible !== onboardingTeamUser.id
      );
    } else {
      return todo.status === TodoStatus.Open;
    }
  }

  const numTodos = todos ? todos.filter(filterRelevantTodos).length : 0;

  if (numTodos === 0) {
    return null;
  }

  return (
    <Badge
      color="error"
      size="sm"
      style={{
        position: "absolute",
        right: "calc(50% - 50px)",
        top: "10px"
      }}
    >
      {numTodos}
    </Badge>
  );
}

export { OnboardingCounter };
